export default __webpack_public_path__ + "static/media/640_dummy2016-delikatessen01.f3325f68.png";